module.exports = __webpack_public_path__ + "static/media/2024_12.3e113232.jpg";